import axios from '@/plugins/axios'
import type IDataResponse from '@/interfaces/api-resources/DataResponse'
import { useAppStore } from '@/stores/app'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return appStore.daraApiBaseUrl
  },

  async getRecent(organisationId: number) {
    return axios.get<
      IDataResponse<App.Http.Resources.ApiV3.OrganisationResourceResource[]>,
      IDataResponse<App.Http.Resources.ApiV3.OrganisationResourceResource[]>
    >(`${ this.baseUrl() }/organisations/${ organisationId }/organisation-resources/`).then(data => data.data)
  },

  async download(organisationResourceId: number) {
    return axios.get<string, string>(`${ this.baseUrl() }/organisation-resources/${ organisationResourceId }/download/`)
  },

  async requestCombinePdfs(organisationId: number, programmeId: number, data: object) {
    return axios.post(`${ this.baseUrl() }/organisations/${ organisationId }/programmes/${ programmeId }/organisation-resources/request-combine-pdf/`, data)
  },

  async requestCombinePdfsForGroups(organisationId: number, programmeId: number, data: object) {
    return axios.post(`${ this.baseUrl() }/organisations/${ organisationId }/programmes/${ programmeId }/organisation-resources/request-combine-pdf-year-groups/`, data)
  },
}
